import React from 'react';
import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';

const EffectOnPlannet = () => {
  return (
    <Container fluid className='effects__main__container'>
      <Container>
        <h1 className='effect__h1 '>
          <AnimatedText
            type='chars' // animate words or chars
            animation={{
              x: '200px',
              y: '-20px',
              scale: 1.1,
              ease: 'ease-in-out',
            }}
            animationType='throw'
            interval={0.06}
            duration={1}
            tag='p'
            className='animated-paragraph'
            includeWhiteSpaces
            threshold={0.1}
            rootMargin='20%'
          >
            THE EFFECTS ON OUR PLANET
          </AnimatedText>
        </h1>
        <Row className='nm np'>
          <Col>
            <p className='plastic__p1'>
              We have, unfortunately, produced more plastic than we can handle,
              and our ecosystem is paying for it.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className='effect__box'>
            <h3 className='effect__h3'> Air </h3>
            <p className='effect__p'>
              {' '}
              When plastic is burned, it releases toxic chemicals into the
              atmosphere and pollutes the air. Microplastics also get carried
              into the air we breathe.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className='effect__box'>
            <h3 className='effect__h3'> Plants </h3>
            <p className='effect__p'>
              {' '}
              Plastics slowly release toxins into the soil and reduce their
              nutrient content, affecting our plants.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className='effect__box'>
            <h3 className='effect__h3'> Land </h3>
            <p className='effect__p'>
              {' '}
              When discarded in landfills, it degrades over time into
              microplastics, which seep into the underlying water table and end
              up in our drinking water. Dumped plastics create trash, which
              takes up useful space and makes it unsuitable for humans and
              animals. As a result, people are displaced and forced to migrate.
              Land animals and birds may become entangled in piled-up plastics,
              resulting in suffocation and death. They may also confuse plastic
              for food and consume poisons as a result.
            </p>
          </Col>
        </Row>
        <Row>
          <Col className='effect__box'>
            <h3 className='effect__h3'> Water </h3>
            <p className='effect__p'>
              {' '}
              Plastics are light, so they can easily be carried by the wind, and
              other climatic elements, into rivers and other water bodies. Once
              at sea, plastics can entrap aquatic animals. Plastic entangles
              tiny marine creatures. Imagine the beautiful creatures being
              choked to death by plastic. These animals may also feed on small
              plastics to their detriment. The plastics may accumulate in their
              guts, causing fullness, reduced appetite, and eventual starvation.
              The plastic also gets tangled with small marine animals. Imagine
              being suffocated to death due to plastic. The tiny synthetic
              polymers may also pierce the GIT during transit and cause fatal
              bleeding and death. Microplastics are ingested by plankton which
              our fish and crabs eat before landing on our plates. The European
              Food Safety Authority has also raised increasing concern for human
              health and food safety "given the potential for microplastic
              pollution in edible tissues of commercial fish."{' '}
            </p>
          </Col>
        </Row>
        <Row>
          <Col className='effect__box'>
            <h3 className='effect__h3'> Humans </h3>
            <p className='effect__p'>
              {' '}
              Fish contains microplastics that we consume. Microplastics and
              other pollutants generated by burning plastics are also breathed
              in by us. Plastics affect our health. The plastic waste ruins our
              beaches or clogs our drainage systems, resulting in flooding.
              Plastic waste has an impact on our general health.{' '}
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default EffectOnPlannet;
